/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which reading frame is used?`)
};

const es_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué marco de lectura se usa?`)
};

const de_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Leseraster wird verwendet?`)
};

const nl_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk leesframe wordt gebruikt?`)
};

const fr_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel cadre de lecture est utilisé ?`)
};

const it_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale fase di lettura viene usata?`)
};

const pt_br2_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual quadro de leitura é usado?`)
};

const pt_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que grelha de leitura é usada?`)
};

const ja_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの読み枠が使われますか？`)
};

const zh_codon_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的是哪个阅读框？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_faq_q4", locale)
	if (locale === "en") return en_codon_faq_q4(inputs)
	if (locale === "es") return es_codon_faq_q4(inputs)
	if (locale === "de") return de_codon_faq_q4(inputs)
	if (locale === "nl") return nl_codon_faq_q4(inputs)
	if (locale === "fr") return fr_codon_faq_q4(inputs)
	if (locale === "it") return it_codon_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_codon_faq_q4(inputs)
	if (locale === "pt") return pt_codon_faq_q4(inputs)
	if (locale === "ja") return ja_codon_faq_q4(inputs)
	return zh_codon_faq_q4(inputs)
};